<div class="w-full bg-white border border-[#f2f2f2] shadow-sm rounded-lg mt-3">
  <!-- Header -->
  <p class="px-4 py-2 border-b border-[#d9d9d9] text-sm sm:text-base text-[#444] font-medium">
    Received Raw Material
  </p>

  <!-- Date Range Tabs -->
  <div class="w-full flex justify-start items-center border-b border-[#d9d9d9]">
    <button (click)="setActiveTab('day')" [ngClass]="{ 'border-b-2 border-[#c19725] text-[#444] font-medium': activeTab === 'day', 'text-[#898989]': activeTab !== 'day' }" class="flex-1 px-4 py-2 text-sm hover:bg-[#f6f1cb] hover:text-black">Day</button>
    <button (click)="setActiveTab('week')" [ngClass]="{ 'border-b-2 border-[#c19725] text-[#444] font-medium': activeTab === 'week', 'text-[#898989]': activeTab !== 'week' }" class="flex-1 px-4 py-2 text-sm hover:bg-[#f6f1cb] hover:text-black">Week</button>
    <button (click)="setActiveTab('month')" [ngClass]="{ 'border-b-2 border-[#c19725] text-[#444] font-medium': activeTab === 'month', 'text-[#898989]': activeTab !== 'month' }" class="flex-1 px-4 py-2 text-sm hover:bg-[#f6f1cb] hover:text-black">Month</button>
    <button (click)="setActiveTab('year')" [ngClass]="{ 'border-b-2 border-[#c19725] text-[#444] font-medium': activeTab === 'year', 'text-[#898989]': activeTab !== 'year' }" class="flex-1 px-4 py-2 text-sm hover:bg-[#f6f1cb] hover:text-black">Year</button>
  </div>

  <!-- Main Content Area -->
  <div class="px-4 py-3">
    <div class="w-full sm:flex justify-between items-start gap-4">
      <!-- Left Side: Controls -->
      <div class="flex flex-col justify-start space-y-4">
        <!-- Material Type Buttons -->
        <div class="flex justify-start gap-2">
          <button (click)="setActiveMaterialTab('metal')" [ngClass]="{ 'text-c19725 border-c19725': activeMaterialTab === 'metal', 'text-[#898989] border-[#898989]': activeMaterialTab !== 'metal' }" class="flex items-center cursor-pointer bg-white text-xs font-bold border px-2 py-1 h-[32px] rounded-sm">
            <img class="size-5 inline me-1.5" src="/assets/images/rmportal/coin1.png" alt="Metal">Metal
          </button>
          <button (click)="setActiveMaterialTab('stone')" [ngClass]="{ 'text-c19725 border-c19725': activeMaterialTab === 'stone', 'text-[#898989] border-[#898989]': activeMaterialTab !== 'stone' }" class="flex items-center cursor-pointer bg-white text-xs font-bold border px-2 py-1 h-[32px] rounded-sm">
            <img class="size-5 inline me-1.5" src="/assets/images/rmportal/mini-diamond.png" alt="Stone">Stone
          </button>
        </div>

        <!-- Date Navigator -->
        <div class="flex items-center">
          <svg (click)="navigateDate('prev')" class="cursor-pointer size-4" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.4 6L8 10.6L6.6 12L0.6 6L6.6 0L8 1.4L3.4 6Z" fill="#C19725" />
          </svg>
          <span class="text-xs md:text-sm text-444 font-medium px-2 text-center" style="min-width: 140px;">{{ displayDate }}</span>
          <svg (click)="navigateDate('next')" class="cursor-pointer size-4" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="#C19725" />
          </svg>
        </div>
      </div>

      <!-- Right Side: Data Display -->
      <div class="w-full sm:w-auto grid grid-cols-3 items-start rounded-md overflow-hidden mt-3 sm:mt-0 flex-grow">
        <!-- Issued -->
        <div class="bg-[#FFFAEC] py-3 px-2 text-center">
          <p class="text-[#323232] font-semibold text-sm lg:text-lg whitespace-nowrap">
            <!-- *** FIX: Conditional Number Formatting *** -->
            {{ totalIssued | number:(activeMaterialTab === 'metal' ? '1.2-2' : '1.0-0') }} {{ displayUnit }}
          </p>
          <span class="text-xs text-444 font-normal">Issued {{ activeMaterialTitle }}</span>
        </div>
        <!-- Submitted -->
        <div class="bg-blue-50 py-3 px-2 text-center border-x border-blue-200">
          <p class="text-[#323232] font-semibold text-sm lg:text-lg whitespace-nowrap">
            <!-- *** FIX: Conditional Number Formatting *** -->
            {{ totalSubmitted | number:(activeMaterialTab === 'metal' ? '1.2-2' : '1.0-0') }} {{ displayUnit }}
          </p>
          <span class="text-xs text-444 font-normal">Submitted {{ activeMaterialTitle }}</span>
        </div>
        <!-- Available -->
        <div class="bg-[#E6FFE2] py-3 px-2 text-center">
          <p class="text-[#323232] font-semibold text-sm lg:text-lg whitespace-nowrap">
            <!-- *** FIX: Conditional Number Formatting *** -->
            {{ totalAvailable | number:(activeMaterialTab === 'metal' ? '1.2-2' : '1.0-0') }} {{ displayUnit }}
          </p>
          <span class="text-xs text-444 font-normal">Available {{ activeMaterialTitle }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
